import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsGridComponent } from './reports-grid/reports-grid.component';
import { ReportsToolbarComponent } from './reports-toolbar/reports-toolbar.component';
import {DxDateBoxModule, DxPivotGridModule, DxSelectBoxModule, DxToolbarModule} from 'devextreme-angular';
import {TabModule} from '../tab/tab.module';



@NgModule({
  declarations: [ReportsGridComponent, ReportsToolbarComponent],
  imports: [
    CommonModule,
    DxDateBoxModule,
    DxToolbarModule,
    TabModule,
    DxPivotGridModule,
    DxSelectBoxModule
  ],
  exports: [ReportsGridComponent]
})
export class ReportsModule { }
